import { Globe } from "lucide-react";
import { useState } from "react";

export function AppIconImage({
  src,
  color,
  sizeClasses,
  iconSizeClasses,
}: Readonly<{
  src: string;
  color: string;
  sizeClasses: string;
  iconSizeClasses: string;
}>) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`${sizeClasses} flex items-center justify-center shrink-0`}
        style={{ backgroundColor: `${color}20` }}
      >
        <Globe className={iconSizeClasses} style={{ color }} />
      </div>
    );
  }

  return (
    <div
      className={`${sizeClasses} flex items-center justify-center shrink-0 overflow-hidden`}
      style={{ backgroundColor: `${color}15` }}
    >
      <img src={src} alt="" className={`${iconSizeClasses} object-contain`} onError={() => setFailed(true)} />
    </div>
  );
}
